import { Component, ViewChild, ElementRef, Input, EventEmitter, Output, OnChanges, SimpleChanges, Renderer } from '@angular/core';
import { DomController } from 'ionic-angular';

/**
 * Generated class for the CustomLineComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-line',
  templateUrl: 'custom-line.html'
})
export class CustomLineComponent implements OnChanges {

  @ViewChild('contenedor') contenedor: ElementRef;
  @Output() newPosition: EventEmitter<any> = new EventEmitter<any>();  

  // color draw
  @Input() color: string;
  @Input() name: string;

  // punto 1
  @Input() x1: number;
  @Input() y1: number;

  // punto 2
  @Input() x2: number;
  @Input() y2: number;

  // seleccionado
  @Input() selected: boolean = false;
  @Input() scroll: number;
  
  // drag zone
  dragZoneWidth: number;
  dragZoneHeight: number;

  private centerX: number;
  private centerY: number;

  svgTopLeftX: number;
  svgTopLeftY: number;

  // puede ser calculado en base a la longitud de la linea
  private minWidth: number = 30;
  private minHeight: number = 30;


  constructor(private renderer: Renderer, private domCtrl: DomController) {
  }


  cambioPosicion(event) {
    this.x1 = this.x1 + (event.x - this.centerX);
    this.y1 = this.y1 + (event.y - this.centerY);
    this.x2 = this.x2 + (event.x - this.centerX);
    this.y2 = this.y2 + (event.y - this.centerY);

    this.recalculateDragZone();
    this.recalculateCenter();
    this.recalculateSvgTopLeftCorner();

    this.renderAt(this.svgTopLeftX, this.svgTopLeftY);
    this.emitPositions();
  }

  private emitPositions() {
    this.newPosition.emit({
      name: this.name,
      position: {
        x1:  this.x1,
        y1:  this.y1,
        x2:  this.x2,
        y2:  this.y2
      }
    })
  }


  private recalculateCenter() {
    this.centerX = (Math.abs(this.x1 - this.x2) / 2) + Math.min(this.x1, this.x2)
    this.centerY = (Math.abs(this.y1 - this.y2) / 2) + Math.min(this.y1, this.y2)
  }

  private recalculateDragZone() {
    this.dragZoneWidth = Math.max(this.minWidth, Math.abs(this.x1 - this.x2))
    this.dragZoneHeight = Math.max(this.minHeight, Math.abs(this.y1 - this.y2))
  }

  private recalculateSvgTopLeftCorner() {
    this.svgTopLeftX = this.centerX - (this.dragZoneWidth / 2);
    this.svgTopLeftY = this.centerY - (this.dragZoneHeight / 2);
  }

  public rotateCounterClockwise(degrees=3) {

    console.log("rotating!!");
    let rotation2 = this.rotate(this.centerX, this.centerY, this.x2, this.y2, degrees);
    this.x2 = rotation2[0];
    this.y2 = rotation2[1];

    let rotation1 = this.rotate(this.centerX, this.centerY, this.x1, this.y1, degrees);
    this.x1 = rotation1[0];
    this.y1 = rotation1[1];

    this.recalculateDragZone();
    this.recalculateCenter();
    this.recalculateSvgTopLeftCorner();

    this.renderAt(this.svgTopLeftX, this.svgTopLeftY)
    this.emitPositions();
  }

  private renderAt(x, y) {
    this.domCtrl.write(() => {
      this.renderer.setElementStyle(this.contenedor.nativeElement, 'left', x + 'px');
      this.renderer.setElementStyle(this.contenedor.nativeElement, 'top', y + 'px');
    });
  }

  private rotate(cx, cy, x, y, angle) {
    let radians = (Math.PI / 180) * angle;
    let cos = Math.cos(radians);
    let sin = Math.sin(radians);
    let nx = (cos * (x - cx)) + (sin * (y - cy)) + cx;
    let ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
    return [nx, ny];
  }

  // to radians
  // private degrees(radians) {
  //   return radians * 180 / Math.PI;
  // }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.x1 || changes.x2 || changes.y1 || changes.y2) {
        this.recalculateDragZone();
        this.recalculateCenter();
        this.recalculateSvgTopLeftCorner();

        //this.render(changes);
        this.renderAt(this.svgTopLeftX, this.svgTopLeftY)
    }
    if (changes.selected) this.renderer.setElementStyle(this.contenedor.nativeElement, 'border', '1px solid ' + (changes.selected.currentValue ? 'white' : 'black'));
  }


  // private render(changes: SimpleChanges) {
  //   this.domCtrl.write(() => {
  //     let x = changes.x.currentValue// - (this.dragZoneWidth / 2)
  //     let y = changes.y.currentValue// - (this.dragZoneHeight / 2)

  //     if (changes.x) this.renderer.setElementStyle(this.contenedor.nativeElement, 'left', x + 'px');
  //     if (changes.y) this.renderer.setElementStyle(this.contenedor.nativeElement, 'top', y + 'px');
  //   });
  // }

}



// WEBPACK FOOTER //
// ./src/components/custom-line/custom-line.ts